import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HeartbeatService } from 'src/app/services/heartbeat/heartbeat.service';
import { StoryService } from 'src/app/services/storyService/story.service';
import * as moment from 'moment';

@Component({
  selector: 'app-export-progress-indicator',
  templateUrl: './export-progress-indicator.component.html',
  styleUrls: ['./export-progress-indicator.component.scss']
})
export class ExportProgressIndicatorComponent implements OnInit {

  @Input() parent:any;
  @Input() num_exports:any = 0;
  @Input() Yiit:any;

  private heartbeat_recieved:any = false;
  private client_id:any = null;

  private queue_pending:any = 0;
  private my_exports_pending:any = [];
  private show_feedback_panel:any = false;
  private queue_pos_label:any = '';
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  public currentExportProgress: Observable<number>;
  public currentExportProgressBS = new BehaviorSubject<number>(0);

  private export_history:any = [];

  constructor(private cd: ChangeDetectorRef, private heartBeatService:HeartbeatService, private storyAdapter:StoryService) { }

  ngOnInit() {
    this.queue_pos_label = this.Yiit.t('Queue position');

    this.setExportHistory();

    this.heartBeatService.setStoriesQuery(true);
    this.heartBeatService.init();
    this.heartBeatService.response$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response) => {
        //if(this.heartbeat_recieved) return;
        ////console.log('HB::', response);
        this.processQueueData(response);
        this.heartbeat_recieved = true;
      });
  }

  public getFromNowDateString(input:any, multiplier:any=1000){
		let one_week_ago:any = moment().subtract(1, 'weeks');
    if(moment(input*multiplier).isAfter(moment())){
      return this.Yiit.t('Pending');
    }
		if(moment(input*multiplier).isAfter(one_week_ago)){
			return moment(input*multiplier).fromNow()
		}else{
			return moment(input*multiplier).format('DD-MM-YYYY hh:mm');
		}
	}

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  showFeedback(){
    this.show_feedback_panel = true;
  }
  hideFeedback(){
    this.show_feedback_panel = false;
  }

  get getExportProgress(){
    let progress:any = parseInt(this.my_exports_pending[0].progress);
    this.currentExportProgressBS.next(progress);
		return this.currentExportProgressBS.asObservable();
  }

  downloadItem(item:any){
    // let url:any = `/stories/${item.client_id}/${item.story_id}/${item.id}/story.pdf`;
    // window.open(url, "_blank");
    // //console.log('downloadItem', item);

    let url:any = `/event-story/download-pdf/${item.id}`;

    // null value in old version with another screenshots path structure format
    if ((item.story_id === '0' || item.story_id === 0) && item.story_id !== null) {
      url = `${window.location.origin}/event-story/download-screenshot/${item.id}/${item.information.slideId}`;
    }

    window.location.href = url;
    //console.log('downloadItem', item);
  }

  setExportHistory(){
    this.export_history = [];
    let cached_history:any = sessionStorage.getItem('export_history');
    if(cached_history){
      let temp_history:any = JSON.parse(cached_history);
      for(let i in temp_history){
        if(temp_history[i].client_id == this.client_id){
          this.export_history.push(temp_history[i]);
        }
      }
    }
  }

  processQueueData(heartbeat:any){

    this.setExportHistory();

    // console.log('@@ heartbeat >> ', heartbeat);

    this.client_id = heartbeat.client_id;

    this.num_exports = 0;
    // let my_exports:any = [];

    // for(let s in this.my_stories){
    //   my_exports.push(parseInt(this.my_stories[s].id));
    // }
    // //console.log('my_exports', my_exports);

    let stories:any = heartbeat.stories;
    this.queue_pending = 0;
    let queue_pos:any = 1;

    this.my_exports_pending = [];

    let queue:any = [];
    let prev_queue_remaining:any = 0;
    let prev_queue_total:any = 0;

    for(let i in stories){
      if(stories[i].status == 'pending' || stories[i].status == 'processing' || stories[i].status == 'processing_pdf' || stories[i].status == 'screenshotted'){

        queue[i] = {
          remaining: parseInt(prev_queue_remaining + (stories[i].total_slides_count - stories[i].generated_slides_count)),
          total: parseInt(prev_queue_total + stories[i].total_slides_count),
        };
        queue[i].processed = queue[i].total-queue[i].remaining;
        queue[i].progress = Math.ceil((queue[i].processed/queue[i].total)*100);
        prev_queue_remaining = queue[i].remaining;
        prev_queue_total = queue[i].total;

        this.queue_pending++;
        stories[i]['queue_position'] = queue_pos;

        // console.log('@@ stories[i].client_id', stories[i].client_id);
        // console.log('@@ this.client_id', this.client_id);

        if(stories[i].client_id == this.client_id){
          stories[i]['queue_status'] = queue[i];
          stories[i]['progress'] = Math.ceil((stories[i].generated_slides_count/stories[i].total_slides_count)*100);
          //if(stories[i]['progress'] < 99){
            stories[i]['updated_at'] = Date.now();
            this.my_exports_pending.push(stories[i]);
            this.num_exports++;
          //}
        }
        queue_pos++;
      }
    }

    this.my_exports_pending.reverse();

    //console.log('==stories==', stories);
    //console.log('queue', queue);
    //console.log('queue_pending', this.queue_pending);
    // console.log('@@ my_exports_pending', this.my_exports_pending, this.my_exports_pending.length);

    let export_history_tmp:any = {};

    for(let i in stories){
      let export_in_history:any = false;

      //console.log('stories[i].status', stories[i].status);
      //console.log('stories[i]', stories[i]);

      for(let j in this.export_history){
        if(stories[i].id == this.export_history[j].id){
          export_in_history = true;
        }
      }
      if(!export_in_history && (stories[i].status == 'completed' || stories[i].status == 'failed')){
        export_history_tmp[stories[i].id] = stories[i];
      }
      // if(!export_in_history){
      //   // this.export_history.push(this.my_exports_pending[i]);
      //   export_history_tmp[this.my_exports_pending[i].id] = this.my_exports_pending[i];
      // }
    }

    //console.log('export_history_tmp', export_history_tmp);

    //this.export_history = [];
    for(let i in export_history_tmp){
      if(export_history_tmp[i].client_id == this.client_id){
        this.export_history.push(export_history_tmp[i]);
      }
    }


    // console.log('@@ this.export_history', this.export_history);

    sessionStorage.setItem('export_history', JSON.stringify(this.export_history));

    this.export_history.reverse();

    this.cd.detectChanges();
  }

}
